import React, { ReactNode } from 'react'

import {
  Space,
  Button,
  Box,
  DisplayPosition,
  Display,
  Color,
  FlexDirection,
  AlignItems,
} from '@gousto-internal/citrus-react'

import { BenefitItem } from 'routes/Home/Benefits/BenefitItem'

type StickyCTAProps = {
  children: ReactNode
  onClick: () => void
  disabled?: boolean
  dataTestId?: string
}

export const StickyCTA = ({ children, onClick, disabled, dataTestId }: StickyCTAProps) => (
  <Box
    bg={Color.White}
    position={DisplayPosition.Fixed}
    display={[Display.Flex, Display.None, null]}
    bottom="0"
    left="0"
    right="0"
    alignItems={AlignItems.Center}
    flexDirection={FlexDirection.Column}
    paddingV={3}
    paddingH={3}
    boxShadow="0 -2px 16px rgba(0, 0, 0, 0.2)"
  >
    <Button
      style={{ paddingLeft: '4px', paddingRight: '4px' }}
      disabled={disabled}
      onClick={onClick}
      width="100%"
      data-testid={dataTestId}
      height="48px"
    >
      {children}
    </Button>
    <Space size={2} />
    <BenefitItem
      iconName="play_pause"
      text="pause or cancel for free anytime"
      strongText="No lock in: "
      ariaLabel="No lock in icon"
    />
  </Box>
)
